import { render, staticRenderFns } from "./CheckEmailPage.vue?vue&type=template&id=fd84899e&"
import script from "./CheckEmailPage.vue?vue&type=script&lang=js&"
export * from "./CheckEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports